import AreaChart from "../../../Reusable/AreaChart";
import AnalyticsStore from "../../../../store/AnalyticsStore";
import EmptyScreen from "../../Equity/EmptyScreen/EmptyScreen";
import {
  formatDateToLocaleDateString,
  getGraphDataInSortedOrder,
} from "../../../../utils/functions";

const colors = {
  equity: "#0469DC",
  balanced: "#59C3C3",
  alternative: "#F45B69",
  fi: "#F0B642",
  cash: "#4a4238",

  // balanced: "#810B7D",
  // alternative: "#DB2255",
  // fi: '#FE7B2C',
  // cash: "#FFA600"
};

const AssetAllocation = ({ chartData }) => {
  // useEffect(() => {
  //   const familyId = UserStore.userData.family_id;
  //   const userId = UserStore.userData.user_id;

  //   getFamilyAssetAllocationOverTime(familyId, userId).then((response) => {
  //     AnalyticsStore.setOverall({
  //       ...AnalyticsStore.overall,
  //       familyAssetAllocationOverTime: [],
  //       assetAllocationLoading: false,
  //     });
  //     if (response.data.length > 0) {
  //       for (let i = 0; i < response?.data?.length; i++) {
  //         for (let j = 0; j < response.data[i].assetAllocations.length; j++) {
  //           const val_type =
  //             response.data[i].assetAllocations[j].assetAllocation.currentValue
  //               .value_type;
  //           const val =
  //             response.data[i].assetAllocations[j].assetAllocation.currentValue
  //               .value;
  //           const allocation_percentage =
  //             response.data[i].assetAllocations[j].assetAllocation
  //               .allocation_percentage;
  //           response.data[i].assetAllocations[
  //             j
  //           ].assetAllocation.currentValue.value_type =
  //             val_type === "lacs" ? "L" : val_type === "k" ? "K" : val_type;
  //           response.data[i].assetAllocations[
  //             j
  //           ].assetAllocation.currentValue.value = commaSeperated2(val);
  //           response.data[i].assetAllocations[
  //             j
  //           ].assetAllocation.allocation_percentage = commaSeperated2(
  //             allocation_percentage
  //           );
  //         }
  //       }
  //       const sortedDatas = [...response?.data].sort(
  //         (a, b) => new Date(a.date) - new Date(b.date)
  //       );
  //       AnalyticsStore.setOverall({
  //         ...AnalyticsStore.overall,
  //         familyAssetAllocationOverTime: sortedDatas,
  //         assetAllocationLoading: false,
  //       });
  //       setCharData(response.data);
  //     } else {
  //       setCharData(null);
  //     }
  //   });
  //   // eslint-disable-next-line
  // }, [AnalyticsStore.overall?.userId, UserStore.getData]);

  return (
    <div>
      <h2
        className="performers asset_allocation_text"
        style={{ marginBottom: "23px" }}
      >
        Your <b>Asset Allocation</b> Over Time
      </h2>
      {chartData ? (
        <div className="asset_allocation_labels">
          <div>
            <div
              className="area_chart_labels"
              style={{ backgroundColor: colors.equity }}
            />
            <span style={{ fontFamily: "Encode Sans" }}>Equity</span>
          </div>
          <div>
            <div
              className="area_chart_labels"
              style={{ backgroundColor: colors.balanced }}
            />
            <span style={{ fontFamily: "Encode Sans" }}>
              Hybrid/Multi Asset
            </span>
          </div>
          <div>
            <div
              className="area_chart_labels"
              style={{ backgroundColor: colors.alternative }}
            />
            <span style={{ fontFamily: "Encode Sans" }}>Alternative</span>
          </div>
          <div>
            <div
              className="area_chart_labels"
              style={{ backgroundColor: colors.fi }}
            />
            <span style={{ fontFamily: "Encode Sans", whiteSpace: "nowrap" }}>
              Fixed Income
            </span>
          </div>
          <div>
            <div
              className="area_chart_labels"
              style={{ backgroundColor: colors.cash }}
            />
            <span style={{ fontFamily: "Encode Sans" }}>Cash</span>
          </div>
        </div>
      ) : (
        ""
      )}
      <div
        className="area__chart__section"
        style={{ width: "96%", marginLeft: "2%" }}
        role="img"
        aria-label="Asset allocation over time chart"
        tabIndex={0}
      >
        {chartData ? (
          <AreaChart
            allocationData={
              AnalyticsStore.overall.familyAssetAllocationOverTime
            }
          />
        ) : chartData == null ? (
          <EmptyScreen />
        ) : (
          <EmptyScreen />
        )}
      </div>
      {chartData && (
        <table className="chart-table-sr-only">
          <caption>Asset allocation over time data</caption>

          <thead>
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Equity</th>
              <th scope="col">Fixed Income</th>
              <th scope="col">Alternative</th>
              <th scope="col">Cash</th>
              <th scope="col">Balanced</th>
            </tr>
          </thead>

          <tbody>
            {getGraphDataInSortedOrder({
              data: AnalyticsStore.overall.familyAssetAllocationOverTime,
            })?.map((item, index) => (
              <tr key={index}>
                <td>{formatDateToLocaleDateString({ dateStr: item.date })}</td>
                {item.assetAllocations?.map((allocations, idx) => (
                  <td key={`${index}-${idx}`}>
                    Currenct value{" "}
                    {allocations?.assetAllocation?.currentValue?.value}
                    {allocations?.assetAllocation?.currentValue?.value_type} ,
                    Allocation Percentages{" "}
                    {allocations?.assetAllocation?.allocation_percentage}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AssetAllocation;
